/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Unexpectederrororcontactus4Inputs */

const en_errors_unexpectederrororcontactus4 = /** @type {(inputs: Errors_Unexpectederrororcontactus4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We encountered an error, please try again later or contact `)
};

/**
* | output |
* | --- |
* | "We encountered an error, please try again later or contact" |
*
* @param {Errors_Unexpectederrororcontactus4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_unexpectederrororcontactus4 = /** @type {((inputs?: Errors_Unexpectederrororcontactus4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Unexpectederrororcontactus4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_unexpectederrororcontactus4(inputs)
});
export { errors_unexpectederrororcontactus4 as "errors_unexpectedErrorOrContactUs" }